import { TELEMETRY_SESSION_KEY } from "@smb/web-telemetry";

export const getTelemetrySessionId = () => {
  return sessionStorage.getItem(TELEMETRY_SESSION_KEY);
};
